<div class="modal-header" style="border: 1px solid #ffffff">
<div class="modal-body text-center" >
  <b>{{title}}</b>
</div>
<div class="modal-footer" *ngIf="title == 'Session Expired'">
    <button type="button" class="btn btn-success" (click)="logout()">Logout</button>
  </div>
</div>

<div class="modal-footer" *ngIf="title != 'Session Expired'">
  <button type="button" class="btn btn-success" (click)="accept()">Confirm</button>
  <button type="button" class="btn btn-danger" (click)="decline()">Cancel</button>
</div>
